import type { IconSvgObject } from './types';

const ZoomIcon: IconSvgObject = [
  ["path", { d: "M2 14V6H10.9945C13.2022 6 15 7.79086 15 10V18H5.99754C3.78976 18 2 16.2091 2 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22.0038 7L17.5 10.0001V14.0001L22.0038 17V7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ZoomIcon;
